import { DateUtil } from '@src/packages/utils/dates';

import type {
  LocationAlert,
  LocationAlertCreateDTO,
  LocationAlertDescription,
  LocationAlertDescriptionDTO,
  LocationAlertDTO,
  LocationAlertUpdateDTO,
} from '../interfaces/locationAlert.interface';

const toDescriptionDTO = (description: LocationAlertDescription): LocationAlertDescriptionDTO => ({
  description: description.description,
  date: description.date
    ? { seconds: Math.floor(description.date.getTime() / 1000), nanoseconds: 0 }
    : undefined,
});

export class LocationAlertMapper {
  static fromDescriptionDTO(dto: LocationAlertDescriptionDTO): LocationAlertDescription {
    return {
      description: dto.description ?? '',
      date: DateUtil.toDateOrNull(dto.date),
    };
  }

  static fromDTO(dto: LocationAlertDTO): LocationAlert {
    const descriptions = (dto.descriptions ?? [])
      .map(LocationAlertMapper.fromDescriptionDTO)
      .sort(
        (a, b) => (DateUtil.getTimestampMs(b.date) ?? 0) - (DateUtil.getTimestampMs(a.date) ?? 0),
      );

    return {
      id: dto.id,
      locationId: dto.locationId ?? dto.id,
      orgId: dto.orgId ?? '',
      divId: dto.divId ?? '',
      quantity: dto.quantity ?? 0,
      descriptions,
      createdAt: DateUtil.toDateOrNull(dto.createdAt),
      updatedAt: DateUtil.toDateOrNull(dto.updatedAt),
    };
  }

  static toResetDTO(): LocationAlertUpdateDTO {
    return {
      quantity: 0,
      descriptions: [],
    };
  }

  static toCreateDTO(params: {
    orgId: string;
    divId: string;
    locationId: string;
    quantity: number;
    descriptions?: LocationAlertDescription[];
  }): LocationAlertCreateDTO {
    const { orgId, divId, locationId, quantity, descriptions } = params;
    return {
      id: locationId,
      locationId,
      orgId,
      divId,
      quantity,
      descriptions: descriptions?.map(toDescriptionDTO),
    };
  }
}
